import { render, staticRenderFns } from "./SecurityCategory.vue?vue&type=template&id=626c2b5c&scoped=true"
import script from "./SecurityCategory.vue?vue&type=script&lang=js"
export * from "./SecurityCategory.vue?vue&type=script&lang=js"
import style0 from "./SecurityCategory.vue?vue&type=style&index=0&id=626c2b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c2b5c",
  null
  
)

export default component.exports